import React from 'react'
import styles from './Heading.module.scss'
// import './Heading.module.scss'

export type HeadingProps = {
    type: string
    text?: string
    style?: any
    classes?: any
    children?: React.ReactNode
}

const Heading = (props: HeadingProps) => {
    const { type, text, style, classes } = props

    const heading = (type: string, text: string) => {
        switch (type.toLowerCase()) {
            case 'h1':
                return (
                    <h1 className={`${classes} ${styles.title}`} style={style}>
                        {props.children ? props.children : text ? text : <></>}
                    </h1>
                )
            case 'h2':
                return (
                    <h2 className={classes} style={style}>
                        {props.children ? props.children : text ? text : <></>}
                    </h2>
                )
            case 'h3':
                return (
                    <h3 className={classes} style={style}>
                        {props.children ? props.children : text ? text : <></>}
                    </h3>
                )
            case 'h4':
                return (
                    <h4 className={classes} style={style}>
                        {props.children ? props.children : text ? text : <></>}
                    </h4>
                )
            case 'h5':
                return (
                    <h5 className={classes} style={style}>
                        {props.children ? props.children : text ? text : <></>}
                    </h5>
                )
            case 'h6':
                return (
                    <h6 className={classes} style={style}>
                        {props.children ? props.children : text ? text : <></>}
                    </h6>
                )
        }
    }

    return heading(type, text)
}

export default Heading
